// extracted by mini-css-extract-plugin
export default {"note":"SingleNote_note__wIWON"};